// src/socket.js (frontend shared client)
import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL || "https://api.bookyourneed.com";

const socket = io(API_URL, {
  withCredentials: true,
  autoConnect: true, // connect once when app mounts
  transports: ["websocket"],
  path: "/socket.io",
});

// Optional: helpful logs
socket.on("connect_error", (err) => {
  console.error("❌ socket connect_error:", err.message);
});

socket.on("connect", () => {
  console.log("✅ socket connected:", socket.id);
});

export default socket;
